<template>
  <div>
    <h1>{{ $t('Запланировать вебинар') }} </h1>
    <validation-observer
        v-slot="{ handleSubmit }"
        ref="refFormObserver"
    >
      <b-form
          ref="form"
          @submit.stop.prevent="handleSubmit(createWebinar($event))"
          class="form validate"
      >
        <validation-provider
            v-slot="validationContext"
            name="link"
        >
          <b-form-group
              :label="$t('Ссылка на конференцию')"
              label-for="link"
              :rules="{required: true}"
          >
            <b-form-input
                placeholder="Введите тему вопроса"
                id="link"
                :state="getValidationState(validationContext)"
                v-model="link"
                trim
            />
            <b-form-invalid-feedback>
              Заполните данное поле
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <div class="select-wrapper">
          <b-form-group
              :label="$t('Выберите группу')"
              label-for="date"

          >
            <v-select
                @option:selected="changeActiveGroup"
                name="group_id"
                :options="allGroups"
                label="name"
                v-model="activeGroupId"
            >
            </v-select>
          </b-form-group>
        </div>
        <div class="select-wrapper">
          <b-form-group
              :label="$t('Выберите урок')"
              label-for="date"

          >
            <v-select
                v-if="activeLessons.length > 0"
                name="lesson_id"
                v-model="activeLessonId"
                :options="allLessons"
                label="name"
            >
              <template #option="{ name, isPast }">
                <h3 style="margin: 0">{{ name }}</h3>
                <em>{{ isPast ? $t('Пройден') : $t('Не пройден') }}</em>
              </template>
            </v-select>

          </b-form-group>
        </div>

        <validation-provider
            v-slot="validationContext"
            name="date"
            :rules="{required: true}"
        >
          <b-form-group
              :label="$t('Дата проведения урока')"
              label-for="date"

          >
            <b-form-input
                type="date"
                placeholder="Введите тему вопроса"
                id="date"
                :state="getValidationState(validationContext)"
                v-model="date"
                trim
            />
            <b-form-invalid-feedback>
              Заполните данное поле
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <validation-provider
            v-slot="validationContext"
            name="time"
            :rules="{required: true}"
        >
          <b-form-group
              :label="$t('Время проведения урока')"
              label-for="time"
          >
            <b-form-input
                type="time"
                id="time"
                :state="getValidationState(validationContext)"
                v-model="time"
                trim
            />
            <b-form-invalid-feedback>
              Заполните данное поле
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <b-button type="submit" variant="primary"> {{ $t('Создать вебинар') }}</b-button>

      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import validationMixin from "@/mixins/getValidationStateMixin";
import vSelect from 'vue-select'
import {BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback} from 'bootstrap-vue'
import {ValidationObserver, ValidationProvider} from 'vee-validate'

const {
  mapState,
  mapActions,
  mapMutations,
  mapGetters,
} = createNamespacedHelpers('teacher');

export default {
  name: 'webinar schedule',
  components: {
    vSelect,
    BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
    ValidationObserver, ValidationProvider
  },
  mixins: [
    validationMixin
  ],
  data() {
    return {
      activeGroupId: '',
      activeLessonId: '',
      link: '',
      date: '',
      time: '',
    };
  },
  computed: {
    ...mapState({
      allGroups: (state) => state.allGroups,
      activeLessons: (state) => state.activeGroupLessons,
      activeGroup: (state) => state.activeGroup,
    }),
    ...mapGetters(['pastLessonIds']),
    allLessons() {
      return this.activeLessons.map((lesson) => {
        if (this.pastLessonIds.indexOf(lesson.id) !== -1) {
          return {
            ...lesson,
            isPast: true,
          };
        }
        return lesson;
      });
    },
  },
  methods: {
    ...mapActions(['getAllGroups', 'createNewWebinar']),
    ...mapMutations(['SET_ACTIVE_GROUP', 'SET_ACTIVE_GROUP_LESSONS', 'SET_PAST_LESSONS']),
    changeActiveGroup() {
      const group = this.allGroups.find((group) => group.id === this.activeGroupId.id);
      this.SET_ACTIVE_GROUP(group);
      this.SET_ACTIVE_GROUP_LESSONS(group.program.lessons);
      this.SET_PAST_LESSONS(group.lessons);
    },
    createWebinar(e) {
      e.preventDefault();
      const options = {
        link: this.link,
        scheduled_date: this.date,
        scheduled_time: this.time,
        group_id: this.activeGroupId.id,
        lesson_id: this.activeLessonId.id,
        is_past: 0,
      };
      this.createNewWebinar(options)
          .then(() => {
            this.$bvToast.toast( this.$t('Вы создали вебинар!'), {
              title: this.$t('Вебинар успешно создан!'),
              variant: 'success',
              solid: true,
            })
            this.$refs.form.reset();
            this.$router.push({name: 'webinars'});
          })
          .catch(() => {
            this.$bvToast.toast( this.$t('Введите корректные данные'), {
              title: this.$t('Введите корректные данные'),
              variant: 'danger',
              solid: true,
            })
          });
    },
  },
  created() {
    this.getAllGroups();
  },
};
</script>

<style scoped>

</style>
